import { Controller } from 'stimulus'
import GoogleCart from 'mixins/google_chart'

export default class extends GoogleCart(Controller) {

  connect() {
    this.googleConnect()
  }

  disconnect() {
    if (this.chart) this.chart.clearChart()
  }

  googleConnected() {
    google.charts.load("current", { 'packages': ['bar'] })
    google.charts.setOnLoadCallback(this.drawChart)
  }

  drawChart = () => {
    this.chart = new google.charts.Bar(this.element)
    this.chart.draw(this.data, google.charts.Bar.convertOptions(this.options))
  }


  get data() {
    return google.visualization.arrayToDataTable(JSON.parse(this.element.dataset.data))
  }

  get options() {
    return {
      chart: {
        title: 'Stages & Detages',
      },
      height: 300,
      legend: { position: 'none' },
      titlePosition: 'none',
      title: '',
      hAxis: { title: '' },
      colors: ['#42C7E8', '#D9D9D9']
    }
  }

}
